module.exports = {
      id: "undraw-post-usage",
      viewBox: "0 0 843.57946 640.51678",
      url: "/assets/icons/" + "sprite.ecb5ac98d0f5af61574884cef75bbacd.svg#undraw-post",
      toString: function () {
        return this.url;
      }
    }